import { useLocalStorage } from "usehooks-ts";

export type ViewMode = "card" | "list";
export type AccountsSection = "internal" | "external";

const STORAGE_KEY_PREFIX = "accountsViewPreference";
const DEFAULT_VIEW: ViewMode = "list";

const useViewPreference = (
  section: AccountsSection
): [ViewMode, (mode: ViewMode) => void] => {
  const [storedView, setView] = useLocalStorage<ViewMode | null>(
    `${STORAGE_KEY_PREFIX}_${section}`,
    null
  );
  return [storedView ?? DEFAULT_VIEW, setView];
};

export default useViewPreference;
